<div class="no-border wrapper flex-center"
     [nbTooltip]="tooltip"
     [nbTooltipDisabled]="tooltip == ''"
     [nbSpinner]="true"
     [nbSpinnerStatus]="status" nbSpinnerSize="medium">
  <nb-icon class="wrapper-icon" [icon]="icon.icon" [pack]="icon.pack" [status]="icon.status"></nb-icon>
</div>
